module.exports = __webpack_public_path__ + "img/id.1a2f72a1.svg";